import { type SidebarBoxConfig } from 'AdmissionsGuidance';
import { type ReactNode, createContext, memo, useContext } from 'react';

const MobileBoxContext = createContext<SidebarBoxConfig | undefined>(undefined);

function MobileBoxContextProviderComponent({
    children,
    boxConfig,
}: {
    children: ReactNode;
    boxConfig: SidebarBoxConfig;
}) {
    return <MobileBoxContext.Provider value={boxConfig}>{children}</MobileBoxContext.Provider>;
}

export function useMobileBoxContext() {
    return useContext(MobileBoxContext);
}

export const MobileBoxContextProvider = memo(
    MobileBoxContextProviderComponent,
) as typeof MobileBoxContextProviderComponent;
